<script>
import Breadcrumb from "../../geral/Breadcrumb.vue";
import jsQR from "jsqr";
import {showToast} from "../../../admin/utils";
import certificadosDigitais from "../../../api/certificados-digitais";

const ETAPAS = Object.freeze({
  SELECIONAR_TRIBUNAL: 'SELECIONAR_TRIBUNAL',
  CONFIGURAR_QR_CODE: 'CONFIGURAR_QR_CODE',
  FINAL: null
});

export default {
  name: "AdicionarMetodoAutenticacao",
  components: {Breadcrumb},
  props: {
    certificado: {
      type: Object,
      required: true,
      default: () => {}
    },
    sistemas: {
      type: Array,
      required: true
    },
    sistemaSelecionado: {
      type: String,
      required: false,
      default: null
    },
  },
  mounted() {
    if (this.sistemaSelecionado) {
      this.etapa = ETAPAS.CONFIGURAR_QR_CODE;
      this.tribunalSelecionado = this.sistemaSelecionado
    }

    this.scrollTo('topo-adicionar-novo-metodo')
  },
  data() {
    return {
      ETAPAS,
      tribunalSelecionado: null,
      etapa: ETAPAS.SELECIONAR_TRIBUNAL,
      imagem: null,
      imagemUrl: null,
      qrCode: {
        resultado: null,
        error: null,
        loading: false,
      },
      form: {
        secret: null,
        codigoVerificacao: null,
      },
      solicitacao: {
        sucesso: null,
        loading: false
      },
      showCameraView: null,
      showQrGuideBox: null,
      erro: null,
      stream: null,
      animationFrameId: null,
      metodo: null
    }
  },
  computed: {
    formInvalido() {
      if (this.etapa === ETAPAS.SELECIONAR_TRIBUNAL) {
        return this.tribunalSelecionado === null;
      }

      if (this.etapa === ETAPAS.CONFIGURAR_QR_CODE) {
        return this.imagemUrl === null
          || (this.form.codigoVerificacao === null || this.form.codigoVerificacao && this.form.codigoVerificacao.length !== 6);
      }
    },
    mensagemResultadoQrcode() {
      if (this.qrCode.loading) {
        return 'Processando imagem...'
      } else if (this.qrCode.resultado) {
        return 'Código escaneado com sucesso'
      } else if (this.qrCode.error) {
        return this.qrCode.error
      } else {
        return null;
      }
    },
    isEditar() {
      return this.sistemaSelecionado;
    },
    passos() {
      if (this.isEditar) {
        return [
          { nome: ETAPAS.CONFIGURAR_QR_CODE, titulo: 'Configuração do QR Code (TOTP)', numero: 1 }
        ];
      } else {
        return [
          { nome: ETAPAS.SELECIONAR_TRIBUNAL, titulo: 'Selecione o Tribunal e Sistema', numero: 1 },
          { nome: ETAPAS.CONFIGURAR_QR_CODE, titulo: 'Configuração do QR Code (TOTP)', numero: 2 }
        ];
      }
    },
    passoAtual() {
      return this.passos.find(p => p.nome === this.etapa);
    },
    passoAtualIndex() {
      return this.passos.findIndex(p => p.nome === this.etapa);
    },
    titulo() {
      return `${this.isEditar ? 'Editar' : 'Adicionar Novo'} Método de Autenticação`;
    },
    etapaTitulo() {
      if (this.etapa === ETAPAS.FINAL) return '';
      return this.passoAtual?.titulo || '';
    }
  },
  methods: {
    getTribunalPorId(id) {
      return this.sistemas.filter(tribunal => tribunal.id === id)[0];
    },
    scrollTo(elementId) {
      document.getElementById(elementId)
        .scrollIntoView({behavior: 'smooth'});
    },
    proximaEtapa() {
      const proximoPasso = this.passos[this.passoAtualIndex + 1];

      if (proximoPasso) {
        this.etapa = proximoPasso.nome;
        this.scrollTo('topo-adicionar-novo-metodo');
      } else {
        this.etapa = ETAPAS.FINAL;
        this.scrollTo('topo-adicionar-novo-metodo');
      }
    },
    voltarParaPaginaGerenciar() {
      window.location.pathname = `/certificados/${this.certificado['id']}/metodos-autenticacao`
    },
    voltar() {
      const passoAnterior = this.passos[this.passoAtualIndex - 1];

      if (this.etapa === ETAPAS.FINAL)  {
        this.etapa = ETAPAS.CONFIGURAR_QR_CODE;
        return;
      }

      if (passoAnterior) {
        this.etapa = passoAnterior.nome;
        if (this.etapa === ETAPAS.CONFIGURAR_QR_CODE) {
          this.fecharCamera();
          this.resetarEtapaTOTP();
        }
        this.scrollTo('topo-adicionar-novo-metodo');
      } else {
        this.voltarParaPaginaGerenciar();
      }
    },
    async abrirCamera() {
      this.resetarQrCode();
      this.qrCode.loading = true;
      this.$refs.cameraDialog.showModal();
      this.showCameraView = true;
      this.showQrGuideBox = true;


      try {
        // Solicita acesso à câmera do usuário (preferindo a câmera traseira)
        this.stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });

        this.$nextTick(async () => {
          if (this.$refs.videoRef) {
            this.$refs.videoRef.srcObject = this.stream;
            this.$refs.videoRef.setAttribute('playsinline', true);
            await this.$refs.videoRef.play();
            this.scanearQRCodeDaCamera();
          }
        });
      } catch (err) {
        showToast(
            "Falha ao acessar a câmera. Por favor, certifique-se de que as permissões foram concedidas e uma câmera está disponível.",
            { type: 'error'}
        );
        this.qrCode.loading = false;
        this.fecharCamera();
      }
    },
    fecharCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }

      if (this.$refs.videoRef) {
        this.$refs.videoRef.srcObject = null;
      }

      if (this.$refs.cameraDialog) {
        this.$refs.cameraDialog.close();
      }

      this.showCameraView = false;
      this.showQrGuideBox = false;
      this.qrCode.loading = false;
    },
    scanearQRCodeDaCamera() {
      if (!this.showCameraView) {
        return;
      }

      if (!this.$refs.videoRef || this.$refs.videoRef.readyState !== this.$refs.videoRef.HAVE_ENOUGH_DATA) {
        this.animationFrameId = requestAnimationFrame(() => this.scanearQRCodeDaCamera());
        return;
      }

      this.metodo = 'camera';

      const imageData = this.carregarCanvas(this.$refs.videoRef);

      const code = jsQR(
          imageData.data,
          imageData.width,
          imageData.height,
          { inversionAttempts: 'dontInvert' }
      );

      this.processarCodigo(code);
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];

      if (!file) {
        showToast('Nenhum arquivo foi selecionado', { type: 'error' });
        return;
      }

      this.metodo = 'upload';
      this.imagem = file;
      this.qrCode.loading = true;

      try {
        const image = await this.carregarImagem(file);

        const imageData = this.carregarCanvas(image);

        const code = jsQR(
          imageData.data,
          imageData.width,
          imageData.height,
          {
            inversionAttempts: 'dontInvert'
          }
        );

      this.processarCodigo(code)

      } catch (err) {
        showToast("Erro ao processar a imagem", {type: 'error'})
        this.resetarQrCode()
      } finally {
        this.qrCode.loading = false;
      }
    },
    carregarCanvas(image) {
      const canvas = this.$refs.qrCanvasRef;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });

      const maxSize = 1000;
      const ratio = Math.min(maxSize / image.width, maxSize / image.height);

      if (image.videoWidth) {
        canvas.width = image.videoWidth;
        canvas.height = image.videoHeight;
      } else {
         canvas.width = image.width * ratio;
         canvas.height = image.height * ratio;
      }


      ctx.drawImage(image, 0, 0);

      return ctx.getImageData(0, 0, canvas.width, canvas.height);
    },
    processarCodigo(codigo) {
      if (codigo) {

        codigo = codigo.data;

        const valido = this.validarCodigo(codigo);

        if (!valido) {
          showToast("QR Code inválido ou não encontrado", { type: 'error' });
          return;
        }

        showToast('Código escaneado com sucesso!');
        this.scrollTo('b-codigo-verificacao-totp');
        this.qrCode.resultado = codigo;
        this.form.secret = new URL(codigo).searchParams.get('secret');

        if (this.metodo === 'camera') {
          this.fecharCamera();
          this.imagemUrl = this.$refs.qrCanvasRef.toDataURL('image/png');
        } else {
          this.imagemUrl = URL.createObjectURL(this.imagem);
        }

        return;
      }

      if (this.metodo === 'camera' && !codigo) {
        this.animationFrameId = requestAnimationFrame(() => this.scanearQRCodeDaCamera());
        return;
      }

      if (!codigo) {
        showToast("QR Code inválido ou não encontrado", { type: 'error' });
        this.resetarQrCode();
      }
    },
    carregarImagem(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          URL.revokeObjectURL(img.src);
          resolve(img)
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
    },
    adicionarNovoMetodo() {
      this.solicitacao.loading = true;

      let data = {
        "codigo_verificacao": this.form.codigoVerificacao,
        "secret": this.form.secret,
      };

      // recupera os ids de this.tribunalSelecionado
      const tribunalEncontrado = this.sistemas.find(t => t.id === this.tribunalSelecionado);

      if (tribunalEncontrado) {
        data['origem_tribunal_sistema_ids'] = tribunalEncontrado.ids;
      } else {
        // Isso não deve acontecer se a validação do formulário estiver correta, mas é uma boa defesa
        console.error("Erro: Tribunal selecionado não encontrado na lista de disponíveis.");
        showToast("Ocorreu um erro ao selecionar o tribunal. Tente novamente.", { type: 'error' });
        this.solicitacao.loading = false;
        return; // Aborta a execução
      }

      let requisicao = certificadosDigitais.adicionarMetodoAutenticacao(this.certificado.id, data);

      requisicao
        .then(() => {
            this.solicitacao.sucesso = true
        })
        .catch(() => {
            this.solicitacao.sucesso = false
        })
        .finally(() => {
          this.proximaEtapa();
          this.solicitacao.loading = false;
        })
    },
    validarCodigo(codigo) {
      try {
        let secret = new URL(codigo).searchParams.get('secret')
        return secret && secret.length >= 16;
      } catch {
        return false;
      }
    },
    voltarNovoTOTP() {
      this.voltar();
      this.resetarEtapaTOTP();
    },
    resetarQrCode() {
      this.qrCode.resultado = null;
      this.metodo = null;
      this.form.secret = null;
      this.imagem = null;
      if (this.imagemUrl) {
        URL.revokeObjectURL(this.imagemUrl);
      }
      this.imagemUrl = null;
      this.resetarValoresObjeto(this.qrCode);
    },
    resetarEtapaTOTP() {
      this.resetarQrCode();
      this.resetarValoresObjeto(this.form);
    },
    resetarValoresObjeto(obj) {
      Object.getOwnPropertyNames(obj).forEach(key => {
        obj[key] = null;
      });
    }
  },
  beforeDestroy() {
    this.fecharCamera();
    this.resetarQrCode();
  },
}
</script>

<template>
  <div id="topo-adicionar-novo-metodo" class="col-sm-10">
    <Breadcrumb :items="[
        { text: 'Certificados Digitais', to: '/certificados' },
        { text: certificado['pessoa_nome'].toUpperCase(), to: `/certificados/${certificado.id}/metodos-autenticacao` },
        { text: (`${this.isEditar ? 'Editar' : 'Adicionar novo' } método` ) , active: true }
      ]" />

    <h1 class="text-2xl font-bold m-0">{{ titulo }}</h1>

    <div class="mt">
      <div v-if="etapa !== ETAPAS.FINAL">
        <div class="bg-white shadow p-4 rounded-md mb-6 border border-gray-200">
          <p class="text-gray-600 m-0">
            <strong>Certificado:</strong>
            <span>
              {{ certificado['pessoa_nome'].toUpperCase() }}  ({{ certificado['pessoa_cpf'] }})
            </span>
          </p>
        </div>

        <div class="mb-4">
          <h2 class="text-xl m-0">Passo {{ passoAtual.numero }} de {{ passos.length }}: {{ passoAtual.titulo }}</h2>
        </div>
      </div>

      <template v-if="etapa === ETAPAS.SELECIONAR_TRIBUNAL">
        <div class="form-box space-y-2">
          <label for="tribunalSistema" class="text-sm font-semibold">Tribunal + Sistema *</label>
          <select
            name="tribunalSistema"
            id="tribunalSistema"
            v-model="tribunalSelecionado"
            class="field px-3 rounded-md text-sm"
          >
            <option :value="null" selected>
              Selecione o tribunal e sistema
            </option>
            <option v-for="tribunal in sistemas" :key="tribunal.id" :value="tribunal.id">
              {{ tribunal.nome }}
            </option>
          </select>
        </div>

        <div class="mt-4">
          <Btn class="btn negative" @click="voltar">Cancelar</Btn>
          <Btn class="btn info" :disabled="formInvalido" @click="proximaEtapa">Próximo</Btn>
        </div>
      </template>

      <template v-if="etapa === ETAPAS.CONFIGURAR_QR_CODE">
        <section class="border-b mb-6">
          <h3 class="text-lg text-gray-700 mb-2 font-semibold">
            A. Obtenha e envie o QR Code
          </h3>
          <p class="text-gray-600 mb-3">
            No sistema
            <span class="font-semibold">{{tribunalSelecionado}}</span>,
            localize a opção de configurar autenticação de dois fatores (TOTP) e obtenha o QR Code.
          </p>

          <p class="mb-4">
            <a target="_blank" href="https://suporte-api.escavador.com/hc/pt-br/articles/39344638701211-Como-Obter-o-QR-Code-para-Autentica%C3%A7%C3%A3o-Multifator-MFA-no-EPROC" class="underline text-blue-500 hover:text-blue-600 hover:underline">
              Não sabe como obter o QR Code no sistema do Tribunal? Clique aqui para um guia.
            </a>
          </p>

          <div class="flex flex-col md:flex-row mb-4 gap-3">
            <Btn class="btn light" @click="abrirCamera">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 100 100">
                <path d="M50,90.883l-1.159-2.007L38.198,70.441l-1.159-2.007l-9.484-16.429L18.07,68.435l-1.159,2.007l-1.451,2.512 c6.98,10.483,18.604,17.602,31.934,18.429c0.751,0.047,1.508,0.075,2.27,0.081c0.112,0.001,0.222,0.009,0.334,0.009 c0.113,0,0.224-0.008,0.336-0.009L50,90.883z" fill="currentColor"/>
                <path d="M85.405,70.441h-2.317H61.802h-2.317h-18.97L50,86.87l1.159,2.007l1.446,2.505c13.33-0.827,24.953-7.945,31.934-18.429 c0.42-0.63,0.819-1.273,1.204-1.927c0.114-0.193,0.226-0.39,0.337-0.585H85.405z" fill="currentColor"/>
                <path d="M87.149,31.566c-0.338-0.68-0.696-1.348-1.07-2.006c-0.11-0.196-0.222-0.391-0.336-0.585l-0.338,0.585l-1.158,2.006 L73.604,50l-1.158,2.006l-9.484,16.428H81.93h2.316h2.903C89.911,62.88,91.472,56.624,91.472,50 C91.472,43.376,89.911,37.12,87.149,31.566z" fill="currentColor"/>
                <path d="M52.605,8.618c-0.751-0.047-1.508-0.075-2.269-0.081c-0.113-0.001-0.224-0.009-0.337-0.009 c-0.112,0-0.222,0.007-0.334,0.008l0.336,0.582l1.158,2.006l10.643,18.435l1.159,2.007l9.484,16.428l9.484-16.428l1.158-2.006 l1.451-2.513C77.559,16.564,65.936,9.446,52.605,8.618z" fill="currentColor"/>
                <path d="M50,13.131l-1.158-2.006l-1.447-2.507c-13.33,0.827-24.953,7.945-31.933,18.428c-0.419,0.629-0.819,1.273-1.204,1.927 c-0.114,0.194-0.225,0.39-0.336,0.585h0.675h2.316l21.287,0h2.316h18.97L50,13.131z" fill="currentColor"/>
                <path d="M18.07,31.565h-2.316h-2.903C10.089,37.12,8.528,43.376,8.528,50s1.561,12.88,4.322,18.435 c0.338,0.681,0.696,1.349,1.07,2.007c0.111,0.195,0.222,0.391,0.336,0.585l0.338-0.585l1.159-2.007L26.397,50l1.158-2.006 l9.485-16.429H18.07z" fill="currentColor"/>
              </svg>
              Abrir Câmera
            </Btn>

            <label class="cursor-pointer">
              <span class="Btn btn light w-full">
                <icon name="upload" size="large"></icon>
                Fazer Upload da Imagem
              </span>
              <input
                type="file"
                name="qr-code"
                accept="image/png, image/jpeg"
                class="hidden"
                @change="handleFileUpload"
                :disabled="showCameraView"
              >
            </label>
          </div>

          <div  id="camera-container" class="preview-box flex flex-col text-center mb-4">
            <div
                :class="{'preview-qrcode' : imagemUrl}"
                class="bg-gray-50 border border-dashed border-gray-300 p-2 rounded-lg w-full text-center"
            >
              <dialog ref="cameraDialog" class="camera-dialog">
                <div v-if="showCameraView">
                  <video ref="videoRef" id="video" class="w-full shadow-md bg-black"></video>
                  <div v-if="showQrGuideBox" class="qr-guide-box"></div>
                  <Btn @click="fecharCamera" class="btn negative w-full relative z-10">
                    Parar Câmera
                  </Btn>
                </div>
              </dialog>

              <img
                  v-if="imagemUrl"
                  :src="imagemUrl"
                  class="rounded-lg border border-gray-300"
                  alt="Pré-visualização do QR-Code"
              >
              <p class="m-0 p-6 text-gray-400 text-sm font-semibold" v-if="!showCameraView && !imagemUrl">
                Pré-visualização do QR Code aparecerá aqui
              </p>
              <canvas ref="qrCanvasRef" class="hidden"></canvas>
            </div>

            <span v-if="mensagemResultadoQrcode"
                  class="text-sm font-semibold mt border px-4 py-3 rounded-md"
                  :class="{
                      'bg-green-100 text-green-700 border-green-400': qrCode.resultado,
                      'bg-red-50 text-red-600 border-red-400': qrCode.error,
                      'bg-gray-50': qrCode.loading
                  }"
            >
               {{ mensagemResultadoQrcode }}
            </span>
          </div>
        </section>

        <section id="b-codigo-verificacao-totp">
          <h3 class="text-lg text-gray-700 mb-2 font-semibold">
            B. Confirme a Configuração
          </h3>
          <p class="text-gray-600 mb-3">
            Após escanear ou enviar o QR Code, a sua aplicação de autenticação (Ex: Google Authenticator)
            exibirá um código. Insira este código abaixo para confirmar.
          </p>

          <div class="form-box space-y-2">
            <label for="" class="text-sm font-semibold"> Código de Verificação TOTP (6 dígitos) </label>
            <input
              name="totp_code"
              v-model="form.codigoVerificacao"
              class="input is-large px-2 rounded-md block"
              type="text"
              required="required"
              autofocus="autofocus"
              placeholder="_ _ _ _ _ _"
              maxlength="6"
            />
          </div>
        </section>

        <div class="mt-4 flex flex-wrap gap-2.5">
          <Btn
              class="btn negative"
              @click="voltar"
              :disabled="solicitacao.loading"
          >
            Voltar
          </Btn>
          <Btn
            class="btn info"
            type="button"
            :loading="solicitacao.loading"
            :disabled="formInvalido || solicitacao.loading"
            @click="adicionarNovoMetodo"
          >
            Verificar e Guardar Configuração
          </Btn>
        </div>
      </template>

      <template v-if="etapa === ETAPAS.FINAL">
        <div class="mb-4 text-center" v-if="solicitacao.sucesso">
          <div class="flex justify-center mb-4 mt-6">
            <span class="bg-green-600 p-1 rounded-3xl">
              <icon name="check" size="largex" class="-highlight"></icon>
            </span>
          </div>
          <h2 class="text-2xl">
            Autenticação Configurada com Sucesso!
          </h2>
          <p class="text-base">
            O método de autenticação TOTP para o sistema <strong>{{ tribunalSelecionado }}</strong> no certificado '{{ certificado['pessoa_nome'].toUpperCase() }}' foi configurado.
          </p>
          <Btn class="btn info" @click="voltarParaPaginaGerenciar">Concluído</Btn>
        </div>

        <div class="mb-4 text-center" v-else>
          <div class="flex justify-center mb-4 mt-6">
            <span class="p-2 rounded-3xl">
              <icon name="close-circle" size="huge" class="-negative -highlight"></icon>
            </span>
          </div>
          <h2 class="text-2xl">
            Falha na Verificação do Código
          </h2>

          <p class="text-base">
            O código de verificação informado está incorreto ou expirou.
            Por favor, confira o código atual na sua aplicação de autenticação e tente novamente.
            Certifique-se de que o QR Code utilizado corresponde ao sistema <strong>{{ tribunalSelecionado }}</strong> e que o relógio do seu dispositivo está sincronizado.
          </p>

          <div class="flex flex-wrap gap-2.5 justify-center">
            <Btn class="btn info" @click="voltar">Tentar novamente</Btn>
            <Btn class="btn info" @click="voltarNovoTOTP">Usar Outro QR Code</Btn>
            <Btn class="btn negative" @click="voltarParaPaginaGerenciar">Cancelar {{ isEditar ? 'Edição' : 'Adição' }}</Btn>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.preview-qrcode
  width 100%
  height 300px
  max-height 400px
  text-align center
  display flex
  justify-content center

  img
    height 100%

.preview-box
  width 100%
  justify-self center

  @media screen and (min-width 769px)
    width 80%

#video
  display: block;
  object-fit: cover;
  height: 450px;

  @media screen and (min-width 769px)
    height: 400px;

.qr-guide-box
  position: absolute;
  top: 46%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 85%;
  border: 3px solid #10B981;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);

  @media screen and (min-width 769px)
    width: 70%;
    height: 70%;

.camera-dialog
  border none
  padding 0
  border-radius 12px
  box-shadow 0 10px 25px rgba(0,0,0,0.2)
  width 90vw
  max-width 600px
  overflow hidden

  // fallback
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)

  @media screen and (min-width 1380px)
    left 28%

.camera-dialog::backdrop
  background-color rgba(0, 0, 0, 0.6)
  backdrop-filter blur(3px)
</style>
